import {RepositoryPickerCurrentRepoServerQuery} from '@github-ui/server-persisted-queries'
import type {RepositoryPickerCurrentRepoServerQueryQuery} from '@github-ui/server-persisted-queries/types/RepositoryPickerCurrentRepoServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export function repositoryQueryKey(owner: string, name: string) {
  return ['item-picker', 'repository', {owner, name}] as const
}

export async function fetchRepositoryFromServer(
  owner: string,
  name: string,
  signal?: AbortSignal,
): Promise<RepositoryPickerCurrentRepoServerQueryQuery['repository']> {
  const query = new URLSearchParams({queryId: RepositoryPickerCurrentRepoServerQuery})
  const response = await reactFetchJSON(`/${owner}/${name}/repository_picker_current_repo.json?${query.toString()}`, {
    signal,
  })

  // The user can't see this repository (not signed into SSO, or it's private/denied), or it was
  // deleted/renamed. This is expected, not a bug: show the picker with no repository pre-selected
  // instead of erroring. We don't reload the page for SSO because this picker opens on top of
  // another page, and reloading would throw away whatever the user was doing.
  if (response.status === 401 || response.status === 403 || response.status === 404) return null

  // A 5xx or other unexpected status is a real failure: throw so the query errors and the picker
  // degrades to no pre-selection. (Genuine 5xxs are already reported server-side.)
  if (!response.ok) throw new Error(`Repository fetch failed (${response.status})`)

  const json = (await response.json()) as {data?: RepositoryPickerCurrentRepoServerQueryQuery}
  // A partial response is still usable, so only fail when there is no data at all.
  if (!json.data) throw new Error('Repository query returned no data')

  return json.data.repository
}
